export class DayMaterialCost {
    constructor({
          id= null,           
          locName= ``, 
          day= ``,            
          materialName= ``,
          materialCode= ``,
          // materialBatch= ``,
          moisture= ``,
          level= ``,
          wetWeight= ``,
          dryWeight= ``,
          
      } = {}) {
      this.id = id;
      this.locName = locName;  
      this.day = day; 
      this.materialName = materialName;
      this.materialCode = materialCode;
      // this.materialBatch = materialBatch;
      this.moisture = moisture;
      this.level = level;
      this.wetWeight = wetWeight;
      this.dryWeight = dryWeight;
    }
  }
  export function gridFields() {
    return Object.freeze([         
        {
          key: 'locName',
          label: 'lbl.basic.locName',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'day',
          label: 'lbl.basic.day',
          sortable: true,
          form: {
            type: 'datepicker'
          }
        },                               
        {
          key: 'materialName',
          label: 'lbl.basic.materialName',
          sortable: false,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'materialCode',
          label: 'lbl.prd.execution.materialCode',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        // {
        //   key: 'materialBatch',
        //   label: 'lbl.prd.execution.materialBatch',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        {
          key: 'moisture',
          label: 'lbl.prd.execution.materialMoisture',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'level',
          label: 'lbl.prd.execution.materialLevel',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'wetWeight',
          label: 'lbl.prd.execution.wetWeight',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'dryWeight',
          label: 'lbl.prd.execution.dryWeight',
          sortable: false,
          form: {
            type: 'input'
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new DayMaterialCost()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.plantFilter',
    'filter.startDayFilter',
    'filter.endDayFilter',  
    'filter.materialFilter',     
  ];
  export const filter = {
    'plantFilter': "",
    'startDayFilter': "",
    'endDayFilter': "",
    'materialFilter': "",
  };